/**
 * @module vuex/state
 */
export default {
    // 选择人员列表
    selectpersonnelList: [],
    // 选择人员是否回到第一级
    selectpersonneIsno: true,
    // 控制整体聊天弹框的大小
    containerSize: {
        height: "100vh",
        width: "100vw",
    },
    // home页面左侧index标识
    homeActiveIndexTag: "消息",
    // 登录中状态
    loading: false,
    // 是否是登录中
    isLoading: false,
    //通讯录选中的公司
    selectItem: {},
    //通讯录公司选中的部门
    depItem:{},

    // IM相关
    // NIM SDK 实例
    nim: null,
    // 登录账户ID
    userUID: null,
    // 用户名片
    myInfo: {},
    // 好友/黑名单/陌生人名片, 数据结构如：{cid: {attr: ...}, ...}
    userInfos: {},
    // 用户订阅的事件同步, 数据结构如：{cid: {typeid: {...}, ...}, ...}
    userSubscribes: {},
    users: '',
    // 好友列表
    friendslist: [],
    // 黑名单列表
    blacklist: [],
    // 禁言列表
    // mutelist: [],

    teamlist: [],
    // 群自身的属性，数据结构如：{tid: {attr: ...}, ...}
    teamAttrs: {},
    // 群对象的成员列表，数据结构如：{tid: {members: [...], ...}, ...}
    teamMembers: {},
    invalidTeams: [],
    currentTeam: '',
    currentTeamMember: '',
    createTeam: '',
    // 当前聊天对象的类型
    currentChatType: "p2p",
    // 消息列表
    msgs: {}, // 以sessionId作为key
    msgsMap: {}, // 以idClient作为key，诸如消息撤回等的消息查找
    // 会话列表
    sessionlist: [],
    sessionMap: {},
    teams: [],
    teamMember: {},
    groupList: [],
    // 当前会话ID（即当前聊天列表，只有单聊群聊采用，可用于判别）
    currSessionId: null,
    currSessionTo: "",
    currSessionMsgs: [],
    // 当前聊天的对象信息
    currChatUserInfo: {
        account: ""
    },
    // 当前聊天的群组信息
    currChatGroupInfo: {},
    // 是否有更多历史消息，用于上拉加载更多
    noMoreHistoryMsgs: false,

    // 系统消息
    sysMsgs: [],
    customSysMsgs: [],
    sysMsgUnread: {
        total: 0,
    },
    customSysMsgUnread: 0,

    // 临时变量
    // 缓存需要获取的用户信息账号,如searchUser
    searchedUsers: [],
    // 缓存需要获取的群组账号
    searchedTeams: [],

    // 聊天室相关
    // 聊天室sdk实例
    chatroomInsts: {},
    chatroomInfos: {},
    // 聊天室分房间消息集合
    chatroomMsgs: {},
    // 当前聊天室实例及id
    currChatroom: null,
    currChatroomId: null,
    currChatroomMsgs: [],
    currChatroomInfo: {},
    // 聊天室成员列表
    currChatroomMembers: [],
}



// WEBPACK FOOTER //
// ./src/store/state.js